import React from 'react'
import TimelineAbsenceDates from 'redesign/components/molecules/timeline-absence-dates'
import TimelineDate from 'redesign/components/molecules/timeline-date'
import TimelineTime from 'redesign/components/molecules/timeline-time'
import TimelineComment from 'redesign/components/organisms/timeline-comment'
import type { AbsenceDateElement } from 'shared/graphql/graphql'
import { newDateWithoutTime } from 'utils/date'
import TimelineReminder from '../timeline-reminder'
import { BodyContainer } from './styles'
import type { TimelineBodyProps } from './types'
import { hasBody } from './utils'

const TimelineElementBody: React.FC<TimelineBodyProps> = ({
  absenceText,
  showDates = false,
  dates,
  dateFrom,
  dateTo,
  showTimelineTime,
  comment,
  children,
  reminder,
  boldText,
}) => {
  const showBody = hasBody({ showDates, dateFrom, showTimelineTime, comment, reminder, children })

  if (!showBody) return null

  return (
    <BodyContainer>
      {showDates ? (
        <TimelineAbsenceDates
          dates={dates as AbsenceDateElement[]}
          dateFrom={dateFrom ?? newDateWithoutTime()}
          dateTo={dateTo ?? newDateWithoutTime()}
        />
      ) : (
        <>
          {dateFrom ? <TimelineDate startDate={dateFrom} endDate={dateTo} /> : null}
          {showTimelineTime && <TimelineTime text={absenceText ?? ''} />}
        </>
      )}
      {Boolean(comment) && <TimelineComment comment={comment} />}
      {Boolean(reminder) && <TimelineReminder reminder={reminder} boldText={boldText} />}

      {children}
    </BodyContainer>
  )
}

export default TimelineElementBody
